var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Inserted products")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.inserted,"dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }